import xmail from "../../../api/api";
import Algorithm from "./Algorithm";

const Constant = {
    MAX_RCPT_SELECTED_COUNT: 1000,             //最多选取收件人数
    MAX_AUTOCOMPLETE_FILTER_RESLUT_COUNT: 200, //自动搜索最多匹配结果数
};


/**
 * 获取组织结构树
 *
 * @param callback
 */
const getCorpOrgTrees = function (callback, version) {
    let orgTrees;
    const key = "CorpOrgTreeInfo#xiaohua.jia@net263.com"; //TODO

    try {
        // orgTrees = JSON.parse(localStorage.getItem(key));
    } catch (e) {
    }
    if (orgTrees) {
        callback(orgTrees);
        return;
    }

    xmail.api.UdcdApp.getCorpOrgVersion({}, function (response) {
        let versionCurr = response.data.data;
        if(versionCurr !== version) {
            xmail.api.UdcdApp.getCorpOrgTreeInfo({}, function (response) {
                // let orgTrees = [];
                let orgTrees = response.data.data;
                // let orgTrees = JSON.parse(JSON.stringify(response.data.data));
                try {
                  // localStorage.setItem(key, JSON.stringify(orgTrees));
                } catch (e) {
                }
                callback(orgTrees);
            });
        } else {
            callback({version: versionCurr});
        }
    });
};

/**
 * 获取个人通讯录树
 *
 * @param callback
 */
const getPersAddressTrees = function (callback, version) {
  let persTrees;
  const key = "CorpOrgTreeInfo#xiaohua.jia@net263.com"; //TODO

  try {
    // orgTrees = JSON.parse(localStorage.getItem(key));
  } catch (e) {
  }
  if (persTrees) {
    callback(persTrees);
    return;
  }
// console.log(version)
  xmail.api.UserContact.getUserContactTreeInfo({contactVersion: version}, function (response) {
    // let persTrees = response.data.data.userContactTrees;
    // let persTrees = JSON.parse(JSON.stringify(response.data.data.userContactTrees));
    // console.log(response)
    // console.log(response.data.data)

    // let persTrees = JSON.parse(JSON.stringify(response.data.data));
    let persTrees = response.data.data;
    // console.log(persTrees)
    try {
      // localStorage.setItem(key, JSON.stringify(persTrees));
    } catch (e) {
    }
    callback(persTrees);
  });
};

/**
 * 从组织结构树中获取匹配的节点
 *
 * @param nodes
 * @param matcher
 * @param maxCount
 * @returns {[]}
 */
const orgTreeCollect = function (nodes, matcher, maxCount) {
    let items = [];
    let count = 0;
    Algorithm.depthWorker(nodes, function (node) {
        if (count >= maxCount) {
            return;
        }
        let res = matcher(node);
        if (res) {
            items.push(res);
            count++
        }
    });
    return items;
};


/**
 * 自动搜索Label
 *
 * @param label
 * @param filterText
 * @returns {*}
 */
const autocompleteLabel = function (label, filterText) {
    if ((typeof label !== "undefined") && (typeof filterText !== "undefined")) {
        let pos = label.indexOf(filterText);
        return pos >= 0 ? {
            first: label.substring(0, pos),
            mid: filterText,
            last: label.substring(pos + filterText.length),
            selected: false
        } : {
            first: label,
            mid: "",
            last: "",
            selected: false
        };
    }
};


export default {
    Constant,
    orgTreeCollect,
    getCorpOrgTrees,
    getPersAddressTrees,
    autocompleteLabel,
};



// WEBPACK FOOTER //
// ./src/components/core/common/OrgContacts.js